import { responseError } from '@/utils/errors';
import { mapResults, selectableResult } from '@/utils/resultsHelper';
import { states } from '@/constants/lifecycle';
import withDraft from '@/utils/draftHelper';
import { requestTaskPermissions } from '../../constants';
import { assignTaskEditProps } from '../../state/state';
import initialState, {
  fetchTaskTemplateState,
  findTaskTemplates,
  showTaskTemplateErrorState,
  showTaskTemplateState,
} from './state';
import actions from '../constants';

const closeTaskTemplates = withDraft((draft, { category }) => {
  draft.tasks.templates[category] = initialState.templates[category];
});

const fetchTaskTemplates = withDraft((draft, action) => {
  const item = findTaskTemplates(draft, action);
  item.readStatus = states.PENDING;
  item.readErrors = [];
});

const showTaskTemplates = withDraft((draft, action) => {
  const item = findTaskTemplates(draft, action);
  item.readStatus = states.SUCCESS;
  item.readErrors = [];
  item.results = action.append
    ? mapResults(item.results, action, selectableResult)
    : mapResults([], action, selectableResult);
  item.pageSize = action.pageSize;
  item.count = action.resultsCount;
  item.currentPage = action.currentPage;
  item.totalPages = action.totalPages;
});

const showTaskTemplatesError = withDraft((draft, action) => {
  const item = findTaskTemplates(draft, action);
  if (item) {
    item.readStatus = states.ERROR;
    item.readErrors = [responseError(action)];
  }
});

const showTaskTemplateSuccess = withDraft((draft, action) => {
  const { activeTask } = draft.tasks;

  if (activeTask.open && activeTask.code === action.taskCode) {
    showTaskTemplateState(draft, action);
    if (activeTask.permissions[requestTaskPermissions.UPDATE]) {
      assignTaskEditProps(activeTask, action.result, true);
    }
  }
});

export default {
  [actions.CLOSE_TASK_TEMPLATES]: closeTaskTemplates,
  [actions.FETCH_TASK_TEMPLATE_FOR_TASK]: fetchTaskTemplateState,
  [actions.FETCH_TASK_TEMPLATES]: fetchTaskTemplates,
  [actions.REFRESH_TASK_TEMPLATES]: fetchTaskTemplates,
  [actions.SHOW_TASK_TEMPLATE_TASK_ERROR]: showTaskTemplateErrorState,
  [actions.SHOW_TASK_TEMPLATE_TASK_SUCCESS]: showTaskTemplateSuccess,
  [actions.SHOW_TASK_TEMPLATES]: showTaskTemplates,
  [actions.SHOW_TASK_TEMPLATES_ERROR]: showTaskTemplatesError,
};
